import request from "../utils/request.js";
import qs from "qs";

/** 节点奖励等 Go 服务 API 根地址 */
const BENTLY_GO_API_BASE = "https://binligo.cointokens.co";// 下单接口
export const submit_order = (data) => {
  return request.post("/api/submit_order", qs.stringify(data));
};

/** 分页参数：pages、limit、wallet 均为字符串 */
export const get_order_list = (data) => {
  return request.post("/api/get_order_list", qs.stringify(data));
};

/** 兑换/提交收货：id、address（均为字符串） */
export const exchange_order = (data) => {
  return request.post("/api/exchange_order", qs.stringify(data));
};

/** 管理员订单列表：pages、limit、status（字符串；1 未发货 2 已发货） */
export const admin_order_list = (data) => {
  return request.post("/api/admin_order_list", qs.stringify(data));
};

/** 管理员发货：id、waybill（均为字符串） */
export const ship_order = (data) => {
  return request.post("/api/ship_order", qs.stringify(data));
};

/** 总业绩、小区业绩、个人级别：wallet 为钱包地址 */
export const get_user_info_api = (data) => {
  return request.post("/api/get_user_info_api", qs.stringify(data));
};

/** 直接下级地址数组：wallet 为钱包地址 */
export const get_referral_list = (data) => {
  return request.post("/api/get_referral_list", qs.stringify(data));
};

/** 获取 V1～V5 奖金池人数（无参） */
export const get_pool_user_num = () => {
  return request.post("/api/get_pool_user_num", qs.stringify({}));
};

/** 分配奖金池前获取各级地址数组：level 为 "1"～"5" */
export const get_level_address = (data) => {
  return request.post("/api/get_level_address", qs.stringify(data));
};

/** 用户提取节点奖励前：由后端写入链上节点奖励数据，wallet 为钱包地址 */
export const set_node_reward = (data) => {
  return request.post(
    `${BENTLY_GO_API_BASE}/api/set_node_reward`,
    qs.stringify(data)
  );
};